export enum BuildDetailsTabId {
  log = 'log',
  tests = 'tests',
  artifacts = 'artifacts',
  buildCache = 'build_cache',
  resources = 'resources',
  details = 'details',
}
